import lengthConfig from '../config/length';

import validateLength from './length';

const validateNote = (value: string): string => validateLength(value, lengthConfig.noteForModerator, 'field-note');

export default validateNote;
